import { Component, Input, OnInit } from '@angular/core';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';
import { WorkshopModel } from '../../../features/workshop/models/workshop.model';

@Component({
  selector: 'app-workshop-row-card',
  templateUrl: './workshop-row-card.component.html',
  styleUrls: ['./workshop-row-card.component.css'],
  standalone: false,
})
export class WorkshopRowCardComponent implements OnInit {
  @Input('workshop') workshop: WorkshopModel;

  // Labels
  teacherLabel: string = '';
  holdingTypeLabel: string = '';
  holdingDateLabel: string = '';
  locationLabel: string = '';

  constructor(private persianTitlesService: PersianTitlesService) {}

  ngOnInit() {
    this.initLabel();
  }

  private initLabel() {
    this.teacherLabel = this.persianTitlesService.Items.Teacher;
    this.holdingDateLabel = this.persianTitlesService.Items.HoldingDate;
    this.holdingTypeLabel = this.persianTitlesService.Items.HoldingType;
    this.locationLabel = this.persianTitlesService.Items.Location;
  }
}
